import { render, staticRenderFns } from "./MH.vue?vue&type=template&id=24ae7a05&scoped=true&"
import script from "./MH.vue?vue&type=script&lang=js&"
export * from "./MH.vue?vue&type=script&lang=js&"
import style0 from "./MH.vue?vue&type=style&index=0&id=24ae7a05&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ae7a05",
  null
  
)

export default component.exports